import React from 'react'
import {Route, Routes} from 'react-router-dom'
import EarlyAccessForm from './components/EarlyAccessForm'
import EarlyAccessSuccess from './components/EarlyAccessInviteSuccess'

export const EarlyAccessRoutes = () => {
  return (
    <div className='mt-3'>
      <Routes>
        <Route
          path='form'
          element={
            <>
              <EarlyAccessForm />
            </>
          }
        />
        <Route
          path='form/success'
          element={
            <>
              <EarlyAccessSuccess />
            </>
          }
        />
      </Routes>
    </div>
  )
}
